import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M13.333 18.6667H15.9997M15.9997 18.6667H18.6663M15.9997 18.6667V21.3333M15.9997 18.6667V16",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M29.3337 15.7304C29.3337 12.2206 29.3337 10.4656 28.3077 9.32495C28.2133 9.22002 28.1135 9.12016 28.0086 9.02579C26.8679 7.99984 25.1129 7.99984 21.6031 7.99984H21.1049C19.5666 7.99984 18.7975 7.99984 18.0808 7.79554C17.6871 7.68331 17.3076 7.52612 16.9498 7.32707C16.2986 6.96473 15.7547 6.42088 14.667 5.33317L13.9333 4.5995C13.5688 4.23494 13.3865 4.05266 13.1949 3.89386C12.369 3.20922 11.3559 2.78955 10.2878 2.68967C10.04 2.6665 9.78223 2.6665 9.26666 2.6665C8.08995 2.6665 7.50159 2.6665 7.01151 2.75897C4.85407 3.16602 3.16651 4.85358 2.75946 7.01102C2.66699 7.5011 2.66699 8.08946 2.66699 9.26617M29.3221 21.3332C29.2742 24.6393 29.029 26.5136 27.7716 27.7711C26.2095 29.3332 23.6953 29.3332 18.667 29.3332H13.3337C8.30534 29.3332 5.79119 29.3332 4.22909 27.7711C2.66699 26.209 2.66699 23.6948 2.66699 18.6665V14.6665",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }, null, -1)
  ])))
}
export default { render: render }